var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"icon",staticClass:"tooltip-icon"},[_vm._t("icon",[_c('InfoIcon')]),_c('q-tooltip',{attrs:{"anchor":_vm.anchor,"self":_vm.self,"offset":_vm.offset}},[_vm._t("content")],2)],2)}
var staticRenderFns = []

export { render, staticRenderFns }